import { Link } from '@inertiajs/react'
import { ReactNode } from 'react'

interface PageHeaderProps {
    title: string
    backUrl?: string
    backText?: string
    icon?: ReactNode
    actions?: ReactNode
}

export default function PageHeader({
                                       title,
                                       backUrl = '/admin',
                                       backText = '← Back to Dashboard',
                                       icon,
                                       actions
                                   }: PageHeaderProps) {
    return (
        <div className="bg-white shadow">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-6">
                    <div className="flex items-center space-x-4">
                        <Link href={backUrl} className="text-indigo-600 hover:text-indigo-700">
                            {backText}
                        </Link>
                        <div className="flex items-center space-x-3">
                            {icon}
                            <h1 className="text-2xl font-bold text-gray-900">
                                {title}
                            </h1>
                        </div>
                    </div>

                    {actions && (
                        <div className="flex items-center space-x-3">
                            {actions}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}